import React from 'react';
import {Check} from "@sparkware/app-utils";
import {PropsWithChildren, useCallback, useEffect} from "react";
import {Button} from "../../../basic-ui-components/button/base/button.component";
import {useServices} from "../../../react-hooks/use-services.hook";
import {onToastButtonClickedAnalytics, onToastOpenedAnalytics} from "../../../services/toaster/toast-helpers/toast-analytics.helper";
import {IToastHandler} from "../../../services/toaster/toaster.service.interface";
import {FlexContainerBox, FlexFixedSizeItemBox, FlexGrowItemBox} from "../../../themes/architecture/css-helpers/flex";
import {StandardToastImageDefaultBox} from "./boxes/standard-toast-image/standard-toast-image.default.box";
import {StandardToastMessageBox} from "./boxes/standard-toast-message/standard-toast-message.box";
import {StandardToastTitleBox} from "./boxes/standard-toast-title/standard-toast-title.box";
import { StandardToastImageBox } from './boxes/standard-toast-image.box';
import {IStandardToastContentProps} from "./standard-toast.component.props";
import {DEFAULT_TOAST_IMAGE} from "../../../services/toaster/taoster-service-consts";



interface IStandardToastContentInternalProps {
    handler: IToastHandler;
}

export const StandardToastContent: React.FC<PropsWithChildren<IStandardToastContentProps & IStandardToastContentInternalProps>> = (props) => {
    const services = useServices();
    const {button, handler} = props;
    const onClick = useCallback(() => {
        onToastButtonClickedAnalytics(services, handler.toastId);
        button.onClick(handler.close);
    }, [services, button, handler]);

    const DefaultIcon = services.theme.currentTheme.icons.infoIcon;
    const renderImage = () => {
        if (!props.image) {
            return null;
        }
        if (props.image === DEFAULT_TOAST_IMAGE) {
            return <StandardToastImageDefaultBox><DefaultIcon size={3} /></StandardToastImageDefaultBox>;
        } else {
            return <StandardToastImageBox><img src={props.image} alt="" /></StandardToastImageBox>;            
        }
    }

    // I put the analytics inside an useEffect because I want to make sure it is run once, at mount, not every rerender
    // handler shouldn't change so it shouldn't rerun at component update
    useEffect(() => {
        onToastOpenedAnalytics(services, handler.toastId);
    }, [handler, services]);

    return <div>
        <FlexContainerBox alignItems="center">
            <FlexFixedSizeItemBox>
                {renderImage()}
            </FlexFixedSizeItemBox>
            <FlexGrowItemBox flexBasis="150px">
                <StandardToastTitleBox>{props.title}</StandardToastTitleBox>
                { Check.isArray(props.message) ?
                    props.message.map(m => <StandardToastMessageBox>{m}</StandardToastMessageBox>) :
                    <StandardToastMessageBox>{props.message}</StandardToastMessageBox> }
                { button ? <Button preset={button.preset ? button.preset : "primary"} sizeVariant="s" fullWidth onClick={onClick} margin="1rem 0 0 auto">{button.text}</Button> : null }
            </FlexGrowItemBox>
        </FlexContainerBox>
    </div>;
}
